import { Box, Flex } from "@otrium/core";
import { MollieComponent } from "../../atoms/MollieComponent";
import { useEffect, useState } from "react";
import { useLingui } from "@lingui/react";
import { msg } from "@lingui/macro";

const MollieCardComponents = ({
  selectedMethod,
}: {
  selectedMethod: string | null;
}) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const { _ } = useLingui();

  useEffect(() => {
    if (selectedMethod === "creditcard") {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [selectedMethod]);

  return (
    <>
      {isVisible && (
        <Box width={"100%"} mb={4} className="mollie-components">
          <Flex flexDirection={["column", "column", "column", "column"]}>
            <Box flex="1">
              <MollieComponent type="cardNumber" name={_(msg`Card number`)} />
            </Box>
          </Flex>
          <Flex flexDirection={["column", "column", "column", "row"]}>
            <Box flex="1">
              <MollieComponent type="expiryDate" name={_(msg`Expiry date`)} />
            </Box>
            <Box flex="1" ml={[0, 0, 0, 4]}>
              <MollieComponent
                type="verificationCode"
                name={_(msg`CVC / CVV`)}
              />
            </Box>
          </Flex>
          <Flex flexDirection={["column", "column", "column", "column"]}>
            <Box flex="1">
              <MollieComponent type="cardHolder" name={_(msg`Card holder`)} />
            </Box>
          </Flex>
        </Box>
      )}
    </>
  );
};
export default MollieCardComponents;
